<div *ngIf="position === OperatorPosition.right">
  <div class="operators-content" *ngIf="showOperatorsPermanently == false">
    <opath-core-nav-header
      style="width: 100%"
      [title]="translation.operators.title"
      [buttons]="operatorButtons"
      [height]="100"
      [hideFilterPanel]="true"
      (onFilterOptionChanged)="filterOptionChanged($event)"
      (onSearchTermChanged)="searchTermChanged($event)"
    >
    </opath-core-nav-header>

    <div class="operators-wrapper" *ngIf="position === OperatorPosition.right">
      <abc-button
        *ngFor="let operator of oPathOperators"
        [width]="'35px'"
        [text]="operator.identifier"
        (click)="onOperatorClick(operator)"
        class="operator-button"
        [toolTipContent]="operator.description"
      >
      </abc-button>
    </div>
  </div>
</div>
<div
  *ngIf="position !== OperatorPosition.right"
  [class]="position === OperatorPosition.left ? 'container-left-position' : 'container-bottom-position'"
  [style.height]="position === OperatorPosition.left ? height + 'px' : '100%'"
  [style.width]="position === OperatorPosition.left ? width + 'px' : '100%'"
>
  <abc-button
    (click)="changePosition(OperatorPosition.right)"
    icon="close"
    [toolTipContent]="translation?.operators.unpin"
    [style.order]="position === OperatorPosition.left ? 1 : 3"
    [ngClass]="
      position === OperatorPosition.left ? 'left-position-close action-btn' : 'buttom-position-close action-btn'
    "
  ></abc-button>
  <div class="buttons-container" id="buttons-container" [style.order]="2">
    <abc-button
      *ngFor="let operator of oPathOperators"
      (click)="onOperatorClick(operator)"
      [width]="'35px'"
      [text]="operator.identifier"
      class="operator-button"
      [toolTipContent]="operator.description"
    >
    </abc-button>
  </div>

  <abc-button
    (click)="
      position === OperatorPosition.left
        ? changePosition(OperatorPosition.bottom)
        : changePosition(OperatorPosition.left)
    "
    [style.order]="position === OperatorPosition.left ? 3 : 1"
    [icon]="position === OperatorPosition.left ? 'chevrondown' : 'chevronleft'"
    [toolTipContent]="translation?.operators.changePosition"
    [ngClass]="
      position === OperatorPosition.left
        ? 'left-position-chevrondown action-btn'
        : 'buttom-position-chevronleft action-btn'
    "
  ></abc-button>
</div>
